import { DEFAULT_THEME } from "@mantine/core";
import type { Rgba } from "./rgba";
import { nearestName, writeCmyk, writeHex, writeHsl, writeHsv, writeLab, writeLch, writeName, writeOklab, writeOklch, writeRgb } from "./write";

export interface FormatSpec {
  id: string;
  label: string;
  write: (colour: Rgba) => string;
  // Only the name box can come up empty, and this is where it says which name it came closest to.
  placeholder?: (colour: Rgba) => string;
}

// The site's own primary, so the page opens on a colour of its own rather than on somebody's idea of a first one.
export const DEFAULT_COLOUR: Rgba = { r: 255, g: 112, b: 67, a: 1 };

// White, which is what a colour is read against until somebody says otherwise and what most of anything is printed on.
export const DEFAULT_BACKGROUND: Rgba = { r: 255, g: 255, b: 255, a: 1 };

// The one box on the page that is not a view of the colour: it takes every notation like the rest and writes hex.
export const BACKGROUND_FIELD: FormatSpec = { id: "background", label: "Background", write: writeHex };

// Mantine's own palette rather than this site's two, since a swatch row nobody can pick a green from is not one.
export const SWATCHES = Object.values(DEFAULT_THEME.colors).map((shades) => shades[6]);

export const FORMAT_ROWS: FormatSpec[][] = [
  [
    { id: "hex", label: "Hex", write: writeHex },
    { id: "name", label: "CSS name", write: writeName, placeholder: (colour) => `≈ ${nearestName(colour)}` },
  ],
  [
    { id: "rgb", label: "RGB", write: writeRgb },
    { id: "hsl", label: "HSL", write: writeHsl },
  ],
  [
    { id: "hsv", label: "HSV", write: writeHsv },
    { id: "cmyk", label: "CMYK", write: writeCmyk },
  ],
  [
    { id: "lab", label: "LAB", write: writeLab },
    { id: "lch", label: "LCH", write: writeLch },
  ],
  [
    { id: "oklab", label: "OKLAB", write: writeOklab },
    { id: "oklch", label: "OKLCH", write: writeOklch },
  ],
];
